import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from "./ui/button";
import logoImage from '../../public/logo.png';

const Navbar = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const toHome = isAdmin ? '/admin/accueil' : '/';
  const toServices = isAdmin ? '/admin/services' : '/services';
  const toPro = isAdmin ? '/admin/professional' : '/professional';
  const toAbout = isAdmin ? '/admin/about' : '/about';
  const toContact = isAdmin ? '/admin/contact' : '/contact';
  const toDashboard = isAdmin ? '/admin/dashboard' : '/dashboard';
  const [logoError, setLogoError] = useState(false);
  const handleLogoError = () => {
    setLogoError(true);
  };
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  return (
    <nav className="bg-gray-900 shadow-lg relative">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-[80px]">
          <Link to={toHome} className="flex items-center space-x-2" aria-label="Accueil">
            {logoError ? (
              <span className="text-white font-heading font-bold text-4xl md:text-5xl leading-none relative top-1 md:top-2">2RENOV</span>
            ) : (
              <img src={logoImage} alt="2RENOV" onError={handleLogoError} className="w-24 h-24 md:w-28 md:h-28 rounded relative top-1 md:top-2" />
            )}
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to={toHome} className="text-gray-300 hover:text-white transition-colors">
              Accueil
            </Link>
            <Link to={toServices} className="text-gray-300 hover:text-white transition-colors">
              Services
            </Link>
            <Link to={toPro} className="text-gray-300 hover:text-white transition-colors">
              Professionnel
            </Link>
            {/* Publicité retirée du menu pour éviter la confusion; pages dynamiques accessibles via URLs dédiées */}
            <Link to={toAbout} className="text-gray-300 hover:text-white transition-colors">
              À propos
            </Link>
            <Link to={toContact} className="text-gray-300 hover:text-white transition-colors">
              Contact
            </Link>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to={toDashboard}>
              <Button variant="default" className="hover:bg-gray-700 text-white">
                Dashboard
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Button variant="ghost" size="icon" className="text-gray-300 hover:text-white" aria-label="Ouvrir le menu" onClick={() => setMobileOpen((v) => !v)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" x2="20" y1="12" y2="12" />
                <line x1="4" x2="20" y1="6" y2="6" />
                <line x1="4" x2="20" y1="18" y2="18" />
              </svg>
            </Button>
          </div>
        </div>
        {mobileOpen && (
          <div className="md:hidden border-t border-gray-800">
            <div className="py-3 space-y-2">
              <Link to={toHome} className="block text-center text-gray-300 hover:text-white transition-colors" onClick={() => setMobileOpen(false)}>
                Accueil
              </Link>
              <Link to={toServices} className="block text-center text-gray-300 hover:text-white transition-colors" onClick={() => setMobileOpen(false)}>
                Services
              </Link>
              <Link to={toPro} className="block text-center text-gray-300 hover:text-white transition-colors" onClick={() => setMobileOpen(false)}>
                Professionnel
              </Link>
              <Link to={toAbout} className="block text-center text-gray-300 hover:text-white transition-colors" onClick={() => setMobileOpen(false)}>
                À propos
              </Link>
              <Link to={toContact} className="block text-center text-gray-300 hover:text-white transition-colors" onClick={() => setMobileOpen(false)}>
                Contact
              </Link>
              <div className="pt-2">
                <Link to={toDashboard} onClick={() => setMobileOpen(false)}>
                  <Button variant="default" className="w-full hover:bg-gray-700 text-white">
                    Dashboard
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
